/**
 * Validation codes from medplum-server/src/fhir-model/role-transition/validate.ts. Their messages are
 * authored by the server and name only resource ids, admin-entered labels, or staff display names that
 * the admin already sees. `execution-failed` (execute.ts) carries raw exception text and is excluded.
 */
export const ROLE_TRANSITION_VALIDATION_CODES: ReadonlySet<string> = new Set([
  'practitioner-out-of-practice',
  'unauthorized',
  'missing-target-role',
  'manager-required',
  'treats-clients-role-conflict',
  'supervises-role-conflict',
  'disposition-out-of-scope',
  'clinical-closeout-required',
  'supervisee-unresolved',
  'supervisee-reassign-required',
  'invalid-replacement-supervisor',
  'pending-cosign-unresolved',
  'group-primary-facilitator-unresolved',
  'group-facilitator-unresolved',
  'client-unresolved',
  'invalid-replacement-provider',
  'transfer-pending-requires-owner',
  'appointment-unresolved',
  'target-role-conflict',
]);

export const TRANSITION_FAILED = 'Transition failed';

/** Message for a failed role transition; in production only validation-coded errors are shown. */
export function formatRoleTransitionErrors(
  errors: ReadonlyArray<{ code: string; message: string }>,
  isProduction: boolean
): string {
  const shown = isProduction ? errors.filter((e) => ROLE_TRANSITION_VALIDATION_CODES.has(e.code)) : errors;
  return shown.map((e) => e.message).join('; ') || TRANSITION_FAILED;
}
